import styled from "styled-components";

const statusColors = {
  orange: {
    text: "#aa5b00",
    bg: "#fcf2e6",
    dot: "#c97a20",
  },
  red: {
    text: "#cf324a",
    bg: "#ffedef",
    dot: "#cf324a",
  },
  blue: {
    text: "#262641",
    bg: "#AAD3FF",
    dot: "#262641",
  },
  grey: {
    text: "#222",
    bg: "#d9d9d9",
    dot: "#222229",
  },
  green: {
    text: "#14804a",
    bg: "#e1fcef",
    dot: "#38a06c",
  },
  yellow: {
    text: "#854d0e",
    bg: "#fef9c3",
    dot: "#ca8a04",
  },
};

export const StyledJourneyStatusTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  width: max-content;
  color: ${({ $text }) => $text};
  background-color: ${({ $bg }) => $bg};

  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: ${({ $dot }) => $dot};
    border-radius: 2px;
  }
`;

export const StyledStatusTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  width: max-content;

  ${({ className }) => {
    const { text, bg, dot } = statusColors[className] || statusColors.grey;
    return `
      color: ${text};
      background-color: ${bg};

      &::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        background-color: ${dot};
        border-radius: 2px;
      }
    `;
  }}
`;

export const StyledTagSpan = styled.span`
  &.in-table {
    align-items: center;
    background: var(--Sky, #cce5ff);
    border-radius: 4px;
    color: var(--Dark-Grey, #262641);
    display: inline-flex;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    height: 24px;
    justify-content: center;
    line-height: 18px;
    padding: 1px 8px;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }
`;
